module.exports = __webpack_public_path__ + "static/media/14UNEP1.2c1e6238.jpg";